import { serializeSuperjson } from '@lib/superjson';
import {
  SendSnapQuoteOutput,
  SendSnapQuoteRequest,
  SendSnapQuoteRequestParams,
} from '@snap-types/actions/send-snap-quote';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildTeamSnapQuoteUrl } from '@ui/store/api-builder/build-team-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

export const SEND_SNAP_QUOTE_MUTATION_KEY = 'sendSnapQuote';

export const [sendSnapQuote, useSendSnapQuoteMutation] = injectMutation<
  SendSnapQuoteRequestParams & SendSnapQuoteRequest,
  SendSnapQuoteOutput
>(
  `${QUOTE_BUILDER_SLICE_NAME}/sendSnapQuote`,
  ({
    snapQuoteUuid,
    siteUuid,
    teamUuid,
    sendEmailToCustomer,
    quotePdfBase64,
    skipOversizedImportFiles,
    forceIgnoreSizeLimits,
  }) => ({
    url: buildTeamSnapQuoteUrl({
      siteUuid,
      teamUuid,
      snapQuoteUuid,
      path: 'send',
    }),
    method: 'POST',
    body: serializeSuperjson({
      sendEmailToCustomer,
      quotePdfBase64,
      skipOversizedImportFiles,
      forceIgnoreSizeLimits,
    }),
  }),
);
